









import { Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';


@Component
export default class DateTime extends Vue {

  //@see https://day.js.org/docs/en/display/format
  @Prop({ default: 'D MMMM YYYY H:mm' })
  private format!: string;

  private formatted = '';

  mounted(){
    if (this.$slots.default?.length) {
      const str = '' + this.$slots.default[0].text;
      this.formatted = dayjs(str).locale('ru').format(this.format);
      // this.$slots.default = [];
      (this.$refs.slot as HTMLElement).remove();
    }
  }
}
